import React, { useEffect, useRef } from "react";
import { OverlayDrawer } from "packages/ui-shared/components/OverlayDrawer";
import { shadeDrawer, shadeSelectorWrapper } from "./ShadeSelectorModal.css";

export type Props = {
  isModalOpen: boolean;
  onCloseModal: React.Dispatch<React.SetStateAction<boolean>>;
  children: React.ReactNode;
  styleVariant?: "default" | "disableScroll";
  drawerHeight?: "default" | "fullHeight";
};

export const ShadeSelectorModal: React.FC<Props> = ({
  isModalOpen = false,
  onCloseModal,
  children,
  styleVariant = "default",
  drawerHeight = "default"
}) => {
  const modalRef = useRef<HTMLDivElement>(null);

  const toggleDrawer = () => {
    onCloseModal(false);
  };

  useEffect(() => {
    if (isModalOpen && modalRef.current) {
      modalRef.current.focus();
    }
  }, [isModalOpen]);

  if (!isModalOpen) return null;

  return (
    <OverlayDrawer
      isOpen={isModalOpen}
      handleDismiss={toggleDrawer}
      className={shadeDrawer[drawerHeight]}
    >
      <div
        className={shadeSelectorWrapper[styleVariant]}
        ref={modalRef}
        tabIndex={-1}
      >
        {children}
      </div>
    </OverlayDrawer>
  );
};
